import React from "react";

import { Button, Typography } from "@material-ui/core";

import FilterNoneIcon from "@material-ui/icons/FilterNone";

import SvgI24Details from "assets/icons/I24Details";
import SvgI24Archive from "assets/icons/I24Archive";
import SvgI24Edit from "assets/icons/I24Edit";

import TrimmedText from "components/TrimmedText";
import PublishStatus from "components/PublishStatus";

import { getPublishButtonIcon, getPublishButtonText } from "utils/publish";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  BottomControlsContainer,
  ControlWrapper,
  StatusContainer,
  StatusWrapper,
} from "./styles";

type Props = {
  title: string;
  duration: string;
  image: string;
  publishStatus: string;
  onDetailsClick: () => void;
  onEdit: () => void;
  onCopy: () => void;
  onArchive: () => void;
  onPublish: () => void;
};

class RecipeCard extends React.Component<Props> {
  render() {
    const {
      title,
      duration,
      image,
      publishStatus,
      onDetailsClick,
      onEdit,
      onCopy,
      onArchive,
      onPublish,
    } = this.props;

    return (
      <Container>
        <ImageContainer image={image} />
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <TrimmedText lines={1} text={title}>
                <Typography variant="h3" color="textPrimary">
                  {title}
                </Typography>
              </TrimmedText>
            </TitleWrapper>
            <Typography variant="subtitle1" color="secondary">
              {duration}
            </Typography>
          </TextContainer>
          <BottomControlsContainer>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Details />}
                variant="text"
                color="secondary"
                onClick={onDetailsClick}
              >
                Details
              </Button>
            </ControlWrapper>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Edit />}
                variant="text"
                color="secondary"
                onClick={onEdit}
              >
                Edit
              </Button>
            </ControlWrapper>
            <ControlWrapper>
              <Button
                startIcon={<FilterNoneIcon />}
                variant="text"
                color="secondary"
                onClick={onCopy}
              >
                Copy
              </Button>
            </ControlWrapper>
            <ControlWrapper>
              <Button
                startIcon={<SvgI24Archive />}
                variant="text"
                color="secondary"
                onClick={onArchive}
              >
                Archive
              </Button>
            </ControlWrapper>
            <ControlWrapper isPublishControl>
              <Button
                startIcon={getPublishButtonIcon(publishStatus)}
                variant="text"
                color="secondary"
                onClick={onPublish}
              >
                {getPublishButtonText(publishStatus)}
              </Button>
            </ControlWrapper>
          </BottomControlsContainer>
        </DetailsContainer>
        <StatusContainer>
          <StatusWrapper>
            <PublishStatus status={publishStatus} />
          </StatusWrapper>
        </StatusContainer>
      </Container>
    );
  }
}

export default RecipeCard;
